import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'loopGroupDecoder'
})
export class LoopGroupDecoderPipe implements PipeTransform {

  transform(value: number): string {

    if (value === 0) {
      return "0 - 一般列印";
    } else if (value === 1) {
      return "1 - 穿插列印";
    } else if (value === 2) {
      return "2 - DO優先順序列印";
    } else {
      return "-";
    }

  }

}
